module.exports = __webpack_public_path__ + "static/media/4ODA16.554adeec.jpg";